import React from "react";
import styles from "./styles.module.css";
import {
  deviceFloorLevel,
  mapOrientation,
  deviceSvgId,
  initScreen,
} from "config/constants";
import { cacheItem, getCachedItem } from "utils/localStorage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      home: window.location.origin,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <p className={styles.p_center}>
            <h1>Something went wrong.</h1>
            <p>
              Please <a href={this.state.home}>click here</a> to go back
            </p>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
